import * as yup from 'yup'

const schema = (isShow) => {
  if (isShow) return yup.object().shape({})

  return yup.object().shape({
    incidentDate: yup
      .date()
      .required('Preencha a data do incidente')
      .typeError('Preencha a data do incidente'),
    incidentHour: yup
      .date()
      .required('Preencha a hora do incidente')
      .typeError('Preencha a hora do incidente'),
    affectedHolders: yup
      .number()
      .min(1, 'O valor não pode ser igual ou menor a zero.')
      .integer()
      .required()
      .typeError('Preencha esse campo corretamente'),
    nameController: yup.string().required(),
    emailController: yup.string().email().required(),
    documentController: yup.string().required(),
    phoneController: yup.string().phone({ required: true }),
    city: yup.string().required(),
    cep: yup.string().required(),
    state: yup.string().required(),
    treatmentHolder: yup
      .number()
      .typeError('Preencha esse campo corretamente')
      .required()
      .min(1, 'O valor deve ser maior de que 0'),
    nameCommissioner: yup.string().required(),
    emailCommissioner: yup.string().email().required(),
    documentCommissioner: yup.string().required(),
    phoneCommissioner: yup.string().phone({ required: true }),
    nameRepresentative: yup.string().required(),
    emailRepresentative: yup.string().email().required(),
    documentRepresentative: yup.string().required(),
    phoneRepresentative: yup.string().phone({ required: true }),
  })
}

export default schema
